import type { NamedEnv } from '@mathflat/shared/@common/devToolbar'
import { mountDevToolbar } from '@mathflat/shared/@common/devToolbar'
import { jwtTokenService } from '@mathflat/shared/@modules/auth/jwtTokenService'
import { useEffect, useRef } from 'react'

import commonRepo from '@/repository/common.repo'
import { RouteName } from '@/router'
import { initAxiosDefaultBaseURL, isNamedEnv } from '@/utils/axios/util'

type UseDevToolbarOptions = {
  enabled?: boolean
  popupProps: { off: boolean; togglePopup: () => void }
}

export function useDevToolbar({ enabled = true, popupProps }: UseDevToolbarOptions) {
  const handleRef = useRef<ReturnType<typeof mountDevToolbar> | null>(null)

  useEffect(() => {
    if (!enabled) return
    const handle = mountDevToolbar({
      onApiEnvApply: (url: string) => {
        jwtTokenService.clearTokens()
        if (isNamedEnv(url)) {
          jwtTokenService.setEnvironment(url)
        } else {
          jwtTokenService.setEnvironment('custom', url)
        }
        initAxiosDefaultBaseURL(url)
        commonRepo.router.push(RouteName.login)
      },
      onSecondaryEnvApply: (_env: NamedEnv, customUrl: string) => {
        jwtTokenService.clearTokens()
        initAxiosDefaultBaseURL(customUrl)
        commonRepo.router.push(RouteName.login)
      },
      popupProps,
    })
    handleRef.current = handle
    return () => {
      handle.unmount()
      handleRef.current = null
    }
  }, [enabled])

  useEffect(() => {
    handleRef.current?.setPopupOff(popupProps.off)
  }, [popupProps.off])
}
